import PropTypes from 'prop-types';
import React from 'react';
import { Check } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const ActionMessage = ({ message }) => {
  return (
    <div className="mt-12 va-m">
      <Check className="c-green mr-8 fw-b svg-align-base" size={22} />
      <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
        <span className="c-green">{message}</span>
      </Text>
    </div>
  );
};

ActionMessage.propTypes = {
  message: PropTypes.string,
};

export default ActionMessage;
